import React from "react";
import { AccountContextProvider } from "./context/AccountContext";
import { ProfileContextProvider } from "./context/ProfileContext";
import { GroupContextProvider } from "./context/GroupContext";
import { BridgeContextProvider } from "./context/BridgeContext";
import { TourProvider } from "./context/TourContext";
const ContextWrapper = ({ children }) => {
  return (
      <TourProvider>
      <ProfileContextProvider>
        <AccountContextProvider>
          <GroupContextProvider>
            <BridgeContextProvider>
            {children}
            </BridgeContextProvider>
            </GroupContextProvider>
        </AccountContextProvider>
      </ProfileContextProvider>
      </TourProvider>

  );
};

export default ContextWrapper;